import moment from 'moment';
import ms from "ms";

import { AuthApi as Api } from "./auth.api";
import LocalStorageKeys from "../../../data/localStorageKeys";

export class AuthFacade {
    /** Si el comerciante actual está autenticado */
    static isLoggedIn() {
        const token = localStorage.getItem(LocalStorageKeys.tokenComercio);

        if (token) {
            const expirationJson = localStorage.getItem(LocalStorageKeys.tokenComercioExpiracion);
            if (expirationJson) {
                const expirationDate = JSON.parse(expirationJson);

                // Si la fecha actual es antes de la fecha de expiración
                return moment().isBefore(expirationDate);
            }
        }

        return false;
    }

    static async logIn(email, password) {
        const response = await Api.logIn(email, password);

        await this.saveLogInData(response);
    }

    static logOut() {
        localStorage.removeItem(LocalStorageKeys.tokenComercio);
        localStorage.removeItem(LocalStorageKeys.tokenComercioExpiracion);
    }

    /**
     * Guarda token y fecha de expiración en localstorage
     * @param {{token: string, expiresIn: string}} data 
     */
    static saveLogInData(data) {
        // Ms es la misma librería que usa el server para convertir a formato milisegundos
        const milliseconds = ms(data.expiresIn);

        // Obtener la fecha de expiración sumando los milisegundos a la fecha actual
        const expirationDate = moment().add(milliseconds, "milliseconds");

        // Guardar token y expiración en localstorage
        localStorage.setItem(
            LocalStorageKeys.tokenComercio,
            // No es necesario pasar a JSON porque es una string
            data.token
        );
        localStorage.setItem(
            LocalStorageKeys.tokenComercioExpiracion,
            // Se pasa a json ya que es un objeto
            JSON.stringify(expirationDate)
        );
    }
}